/** Mantém a ordem do cadastro e remove paths duplicados. */
export function uniqueOrderedPaths(paths: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const p of paths) {
    const t = p.trim();
    if (!t || seen.has(t)) continue;
    seen.add(t);
    out.push(t);
  }
  return out;
}

/**
 * Paths da galeria do resort: fotos do cadastro (`photos`), capa, e por fim o `logo`
 * quando não há galeria/capa (caso real em produção: API só com `logo` preenchido).
 */
export function buildResortGalleryPaths(params: {
  photoPaths: string[];
  coverImagePath: string | null;
  logoPath?: string | null;
}): string[] {
  const { photoPaths, coverImagePath, logoPath } = params;
  const ordered = uniqueOrderedPaths(photoPaths);
  const coverKey = (coverImagePath || "").trim();

  if (ordered.length > 0) {
    if (coverKey) {
      const withoutCover = ordered.filter((p) => p.trim() !== coverKey);
      return (withoutCover.length > 0 ? withoutCover : ordered).slice(0, 8);
    }
    return ordered.slice(0, 8);
  }

  if (coverKey) {
    return [coverImagePath!.trim()];
  }

  const logo = logoPath?.trim();
  if (logo) {
    return [logo];
  }

  return [];
}
